import instance from '../axios-instance';

export const getUsers = async (): Promise<UserResponse> => {
  return (await instance.get(`app/users`)).data;
};

export const getUser = async (id: number): Promise<IUser> => {
  return (await instance.get(`app/users/${id}`)).data.data;
};

export const addUser = async <T>(data: T) => {
  return (await instance.post(`app/users`, data)).data;
};

export const updateUser = async <T>(id: number, data: T) => {
  return (await instance.post(`app/users/${id}?_method=PUT`, data)).data;
};

export const addComment = async <T>(Id: string | undefined, data: T) => {
  return (await instance.post(`app/users/${Id}/comments`, data)).data;
};

export const acceptUser = async <T>(Id: number) => {
  return (await instance.post(`app/users/${Id}?_method=PUT&status=1`)).data;
};

export const deleteUser = async (id: number) => {
  return (await instance.delete(`app/users/${id}`)).data;
};

interface UserResponse {
  data: IUser[];
  links: Links;
  meta: Meta;
}

interface Meta {
  current_page: number;
  from: number;
  path: string;
  per_page: number;
  to: number;
}

interface Links {
  first: string;
  last?: any;
  prev?: any;
  next?: any;
}
export interface Comment {
  id: number;
  comment: string;
  created_at: string;
  is_reason: number | null;
  user: {
    id: number;
    name: string;
    image?: string;
  };
}

interface Appointment {
  id: number;
  appointment_nr: string;
  date: string;
  time_from: string;
  time_to: string;
  duration: number;
  price: number;
  status: string;
}

export interface IUser {
  id: number;
  status_value: number | string;
  gender_value: string;
  name: string;
  first_name: string;
  last_name: string;
  phone?: string;
  phone_number: string;
  phone_code: number;
  email: string;
  gender: string;
  date_of_birth: string | null;
  status: string;
  comments: {
    data: Comment[];
  };
  appointments: {
    data: Appointment[];
  };
  language: {
    id: number;
    name: string;
  };
  country: {
    id: number;
    name: string;
    code_alpha_2: string;
    code_alpha_3: string;
    currency_code: string;
    currency_symbol: string;
    phone_code: number;
  };
}

interface Permissions {
  data: Datum[];
}

interface Datum {
  name: string;
}
